import NavigationLayout from "../navigation/navigation-layout.js";
import FooterLayout from '../footer/footer-layout.js';
import ContactView from "./contact-view.js";
import { useEffect } from "react";

const ContactLayout = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <NavigationLayout />

            <ContactView />

            <FooterLayout />
        </>
    );
}

export default ContactLayout;